import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'VOLUNTEER_UPDATE',
    smsDelete : 'VOLUNTEER_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        volunteer: [],
        volunteerDetails: null,
        submitSuccess: false,
        volunteerLoading: false,
        volunteerError: false,

        volunteerType: [],
        volunteerTypeLoading: false,
        volunteerTypeError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_VOLUNTEER(state, volunteer) {
            state.volunteer = volunteer;
        },

        SET_VOLUNTEER_DETAILS(state, volunteer) {
            state.volunteerDetails = volunteer;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        VOLUNTEER_LOADING (state, loading) {
            state.volunteerLoading = loading;
        },

        VOLUNTEER_ERROR (state, hasError) {
            state.volunteerError = hasError;
        },

        SET_VOLUNTEER_TYPE(state, volunteer_type) {
            state.volunteerType = volunteer_type;
        },

        VOLUNTEER_TYPE_LOADING (state, loading) {
            state.volunteerTypeLoading = loading;
        },

        VOLUNTEER_TYPE_ERROR (state, hasError) {
            state.volunteerTypeError = hasError;
        }
    },

    actions: {
          async addType ({commit, dispatch}, payload) {
            commit('VOLUNTEER_TYPE_LOADING', true);
            commit('VOLUNTEER_TYPE_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_volunteer_type, payload.volunteer, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchType')
                return response

            } catch (e) {
                commit('VOLUNTEER_TYPE_ERROR', true);
            } finally {
                commit('VOLUNTEER_TYPE_LOADING', false);
            }
        },

        async fetchType ({ commit }) {
            commit('VOLUNTEER_TYPE_LOADING', true);
            commit('VOLUNTEER_TYPE_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.volunteer_type_list, config);
                let response = result.data
                commit('SET_VOLUNTEER_TYPE', response.data);

            } catch(error) {
                commit('VOLUNTEER_TYPE_ERROR', true);
            } finally {
                commit('VOLUNTEER_TYPE_LOADING', false);
            }
        },

         async updateType ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.patch(V1API.update_volunteer_type + payload.id, payload.volunteer, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchType')
                return response

            } catch (e) {
                commit('VOLUNTEER_TYPE_ERROR', true);
            } finally {
                commit('VOLUNTEER_TYPE_LOADING', false);
            }
        },
        
        async deleteType({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.volunteer_type_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchType')
            return response
        },

        async addVolunteer ({commit, dispatch}, payload) {
            commit('VOLUNTEER_LOADING', true);
            commit('VOLUNTEER_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_volunteer, payload, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchVolunteer')
                return response

            } catch (e) {
                commit('VOLUNTEER_ERROR', true);
            } finally {
                commit('VOLUNTEER_LOADING', false);
            }
        },

        async fetchVolunteer ({ commit }) {
            commit('VOLUNTEER_LOADING', true);
            commit('VOLUNTEER_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let result = await axios.get(V1API.volunteer_list, config);
                let response = result.data
                commit('SET_VOLUNTEER', response.data);

            } catch(error) {
                commit('VOLUNTEER_ERROR', true);
            } finally {
                commit('VOLUNTEER_LOADING', false);
            }
        },

        async fetchVolunteerByType ({ commit }, payload) {
            commit('VOLUNTEER_LOADING', true);
            commit('VOLUNTEER_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.volunteer_list_by_type + payload, config);
                let response = result.data
                commit('SET_VOLUNTEER', response.data.volunteer);

            } catch(error) {
                commit('VOLUNTEER_ERROR', true);
            } finally {
                commit('VOLUNTEER_LOADING', false);
            }
        },

        async fetchVolunteerDetails ({ commit }, payload) {
            commit('VOLUNTEER_LOADING', true);
            commit('VOLUNTEER_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.volunteer_details + payload, config);
                let response = result.data
                commit('SET_VOLUNTEER_DETAILS', response);

            } catch(error) {
                commit('VOLUNTEER_ERROR', true);
            } finally {
                commit('VOLUNTEER_LOADING', false);
            }
        },

        async getVolunteersByUpazila ({ commit }, payload) {
            commit('VOLUNTEER_LOADING', true);
            commit('VOLUNTEER_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.volunteer_list_by_upazila + payload, config);
                let response = result.data
                commit('SET_VOLUNTEER', response.data);

            } catch(error) {
                commit('VOLUNTEER_ERROR', true);
            } finally {
                commit('VOLUNTEER_LOADING', false);
            }
        },

        async updateVolunteer ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.patch(V1API.update_volunteer + payload.id, payload.volunteer, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchVolunteer')
                return response

            } catch (e) {
                commit('VOLUNTEER_ERROR', true);
            } finally {
                commit('VOLUNTEER_LOADING', false);
            }
        },
        
        async deleteVolunteer({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.volunteer_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchVolunteer')
            return response
        }
    },

    getters: {}
}
